import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen:", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    setGyseFormOpen(state) {
        state.gyseFormIsOpen = true;
        state.gyseGridIsOpen = false;
    },
    setGyseFormClose(state) {
        state.gyseFormIsOpen = false;
        state.gyseGridIsOpen = true;
    }
}
